import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";

const DocumentViewer = ({
  openDocDialog,
  handleCloseDocDialog,
  documentUrl,
}) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  return (
    <Dialog
      open={openDocDialog}
      maxWidth="xl"
      fullWidth
      onClose={handleCloseDocDialog}
    >
      <DialogContent>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <IconButton
            onClick={handleCloseDocDialog}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </Box>
        {documentUrl?.mimeType?.includes("pdf") ? (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer
              fileUrl={documentUrl.url}
              plugins={[defaultLayoutPluginInstance]}
            />
          </Worker>
        ) : documentUrl?.mimeType?.startsWith("image/") ? (
          <img
            src={documentUrl.url}
            alt="Progress Note"
            style={{ maxWidth: "100%", maxHeight: "75vh" }}
          />
        ) : (
          <Typography color="text.secondary">
            Unsupported file type: {documentUrl?.mimeType || "unknown"}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DocumentViewer;
